module.exports = __webpack_public_path__ + "img/cal-pre-mobile-fa.f10016e8.png";